import React from 'react';
import { Utensils, Users, MapPin, Heart } from 'lucide-react';
import { impactStats } from '../mock';

const iconMap = {
  'utensils': Utensils,
  'users': Users,
  'map-pin': MapPin,
  'heart': Heart
};

const ImpactStats = () => {
  return (
    <section id="impact" className="py-20 bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Impact
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            Together, we've created a meaningful difference in the lives of thousands across Ayodhya region. 
            Here's a glimpse of our journey so far.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {impactStats.map((stat, index) => {
            const IconComponent = iconMap[stat.icon];
            return (
              <div
                key={stat.id}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-t-4 border-teal-600"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full flex items-center justify-center mb-4 shadow-lg">
                    <IconComponent className="text-white" size={28} />
                  </div>
                  <div className="text-4xl font-bold text-gray-900 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-600 font-medium">
                    {stat.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-xl text-gray-700 font-medium">
            Every number represents a life touched, a smile restored, and a hope renewed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;
